import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import {
  downloadDocApiCall,
} from "./constants/HandleChangeFunctions";
import { fetchDocumentsForCustomer } from "../../slices/customer/documentlist/thunk";
import { useLocation } from "react-router-dom";
import { customerIdData } from "./constants/constantFunctionsView";
import { Box } from "@mui/material";
import moment from "moment";
import StatusBadge from "./StatusBadge";
import { formatCellValue, formatDateForDisplay } from "../Utils/UtilityFunctions";
import { hasPermission } from "../Utils/UtilityFunctions";

export default function UploadDocumentTable() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const customerId = customerIdData();
  useEffect(() => {
    if (customerId) {
      dispatch(fetchDocumentsForCustomer(setLoading, customerId));
    }
  }, [dispatch, setLoading, customerId]);

  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const documentPermission = hasPermission(permissionsMap, "miscellaneous", "document")

  const fetchDocumentData = useSelector(
    (state) => state.DocumentList.documentList
  );
  const columns = [
    {
      accessorKey: 'documentName',
      header: 'Document Name',
      Cell: ({ cell }) => formatCellValue(cell.getValue())

    },
    {
      accessorKey: 'fileName',
      header: 'File Name',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'documentType',
      header: 'Document Type',
      Cell: ({ cell }) => formatCellValue(cell.getValue())

    },
    {
      accessorKey: 'uploadedtime',
      header: 'Uploaded Date & Time',
      size: 200,
      Cell: ({ cell }) => formatCellValue(cell.getValue(), val => (
        <Box>
          {moment(val).format('DD MMM YYYY')}
        </Box>))
    },

    {
      accessorKey: 'status',
      header: 'Status',
      Cell: ({ cell }) => {
        let statusValue = cell.getValue();
        return <StatusBadge value={statusValue} />;
      },
    },


  ]
  return (
    <div className="border rounded-1 px-0 py-3 my-2 bg-white">
      {fetchDocumentData?.length > 0 ? (
        <MaterialReactTable
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "",
              enableHiding: true,
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontFamily: "Inter,sans-serif",
              color: "#343A40",
              padding: "4px",
            },
          }}
          muiTablePaperProps={{
            elevation: 0,
          }}
          muiTableBodyCellProps={{
            sx: {
              fontFamily: "Inter,sans-serif",
              padding: "4px",
            },
          }}
          enableDensityToggle={false}
          renderRowActionMenuItems={({ closeMenu, row }) => [
            documentPermission && documentPermission?.has("download") ?
              <MenuItem
                key={`${row.index}.3`}
                onClick={() => {
                  downloadDocApiCall(
                    dispatch,
                    setLoading,
                    customerId,
                    row.original.documentName
                  );
                  closeMenu();
                }}
              >
                <i className="ri-download-line me-2" /> Download
              </MenuItem> : null,
          ]}
          enableRowActions
          enableBottomToolbar={false}
          enableSorting={false}
          enableColumnActions={true}
          enablePagination={false}
          enableTopToolbar={false}
          data={fetchDocumentData}
          columns={columns}
        />
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
          No record to display
        </div>
      )}
    </div>
  );
}
